<template>
  <div>
    <h1>404</h1>
    <p>This page doesn't seem to exist</p>
    <p>Here is a cool image instead:</p>
    <p><magma /></p>
  </div>
</template>

<script>
import Magma from './MagmaReef.vue';

export default {
  name: 'unknown-page',
  components: { Magma },
};
</script>
